export default __webpack_public_path__ + "static/media/EM0230.34I-22673_-15173_0.b22128c0.jpg";